export default "__VITE_ASSET__18b9ae73__"